var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMultiVideoStream(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icMultiVideoStream") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-18.0%",
    width: "136.0%",
    height: "136.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.968627451   0 0 0 0 0.419607843   0 0 0 0 0.274509804  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.7092171,0.57792238 C30.5623601,0.525931257 30.4211423,0.49982624 30.285445,0.49982624 C29.9803339,0.49982624 29.7263912,0.598992467 29.5228453,0.796777645 L22.6928673,7.07818097 L22.6928673,4.50007799 C22.6928673,3.26033597 22.215493,2.2005927 21.2607445,1.32030089 C20.3059366,0.44011854 19.1566055,0 17.8118015,0 L5.88082836,0 C4.53643985,0 3.38675261,0.44011854 2.43188536,1.32030089 C1.47737427,2.2005927 1,3.26033597 1,4.50007799 L1,15.5000862 C1,16.7397188 1.47737427,17.7994073 2.43194472,18.6796444 C3.38681197,19.5598815 4.53649921,20 5.88088772,20 L17.8119202,20 C19.1566649,20 20.3060553,19.5598815 21.2608632,18.6796444 C22.2156117,17.7994073 22.692986,16.7397735 22.692986,15.5000862 L22.692986,12.906167 L29.522964,19.2031676 C29.7265099,19.4008981 29.9804526,19.5 30.2855638,19.5 C30.4212611,19.5 30.5624788,19.4739593 30.7093358,19.4220776 C31.1502036,19.2449247 31.3703704,18.9377393 31.3703704,18.5002476 L31.3703704,1.500026 C31.3703704,1.06231547 31.1500255,0.755075291 30.7092171,0.57792238 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RedHotPie-Premium+-upgrade",
    transform: "translate(-9.000000, -1325.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 1110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icMultiVideoStream",
    transform: "translate(15.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "menuIcon-1-04",
    transform: "translate(9.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F76B46",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("text", {
    id: 3,
    mask: "url(#mask-4)",
    fontFamily: "Muli-ExtraBold, Muli",
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: -0.7,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8.15,
    y: 15
  }, "3"))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMultiVideoStream);
export default __webpack_public_path__ + "static/media/icMultiVideoStream.33eb9fd4384fe5ad74628aa7a220d22d.svg";
export { ForwardRef as ReactComponent };